// Сами документы — только на русском (пакет `legal`); здесь подписи экранов:
// заголовок списка, короткое имя документа для шапки и строка о редакции.
export default {
  en: {
    title: 'Documents',
    short_privacy: 'Privacy policy',
    short_offer: 'Public offer',
    short_consent: 'Consent',
    updated: 'Version of {{date}}',
  },
  ru: {
    title: 'Документы',
    short_privacy: 'Политика',
    short_offer: 'Оферта',
    short_consent: 'Согласие',
    updated: 'Редакция от {{date}}',
  },
  de: {
    title: 'Dokumente',
    short_privacy: 'Datenschutz',
    short_offer: 'Angebot',
    short_consent: 'Einwilligung',
    updated: 'Fassung vom {{date}}',
  },
  pt: {
    title: 'Documentos',
    short_privacy: 'Privacidade',
    short_offer: 'Oferta',
    short_consent: 'Consentimento',
    updated: 'Versão de {{date}}',
  },
  fr: {
    title: 'Documents',
    short_privacy: 'Confidentialité',
    short_offer: 'Offre',
    short_consent: 'Consentement',
    updated: 'Version du {{date}}',
  },
  es: {
    title: 'Documentos',
    short_privacy: 'Privacidad',
    short_offer: 'Oferta',
    short_consent: 'Consentimiento',
    updated: 'Versión del {{date}}',
  },
};
